import { inject, Injectable } from '@angular/core';
import { IPosition } from '@app/core/interfaces/position.interface';
import { PipesMockService } from '@mock/data-services/pipes-mock.service';

@Injectable({ providedIn: 'root' })
export class MarkersService {
  private pipesPositions: IPosition[][] = inject(PipesMockService).pipesPositions;

  public generateMarkersPositions(count: number, pointsPerSegment = 3): IPosition[] {
    const uniquePointsMap = new Map<string, IPosition>();

    for (const pipe of this.pipesPositions) {
      for (let i = 0; i < pipe.length - 1; i++) {
        const start = pipe[i];
        const end = pipe[i + 1];

        for (let j = 0; j <= pointsPerSegment; j++) {
          const t = j / pointsPerSegment;

          const lat = start.lat + (end.lat - start.lat) * t;
          const lon = start.lon + (end.lon - start.lon) * t;

          const key = `${lat.toFixed(7)},${lon.toFixed(7)}`;
          uniquePointsMap.set(key, { lat, lon });
        }
      }
    }

    const uniquePoints = Array.from(uniquePointsMap.values());

    if (uniquePoints.length === 0) {
      console.warn('[Generated data] No available positions');
      return [];
    }

    if (uniquePoints.length <= count) {
      return uniquePoints;
    }

    const arr = [...uniquePoints];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr.slice(0, count);
  }
}
